import { ILocalStorageRepository } from "Infrastructure/interfaces/ILocalStorageRepository";
import { getGlobalAddLog } from "../appInsights/AppInsights";
import { LocalStorageRepository } from "./_LocalStorageRepository";
import { Order } from "domains/order/agreggates/order/Order";
import { PedidoPos, responseSyncPedidoPos } from "../../interfaces/PedidoMeep";
import { OrderRepositoryLocalStorage } from "./OrderRepositoryLocalStorage";
import { ILocalStorageCashlessOfflineRepository } from "../../../domains/order/interfaces/repositories/ILocalStorageCashlessOfflineRepository";

const KEY = "@meep/CashlessOffline";

const addLog = getGlobalAddLog();
const localStorageRepository: ILocalStorageRepository =
  LocalStorageRepository();
const orderRepository = OrderRepositoryLocalStorage();

export const LocalStorageCashlessOfflineRepository =
  (): ILocalStorageCashlessOfflineRepository => {
    const getStoragePendentRecordConfirmationOrder = async (): Promise<
      PedidoPos[]
    > => {
      const storagePedidosPOS: PedidoPos[] =
        (await localStorageRepository.get<PedidoPos[]>(KEY))?.filter(
          (it) => it.isDataRecorded && !it.isOfflineRechargeRecordConfirmed
        ) ?? [];
      addLog &&
        addLog("[CashlessOfflineRepository]", {
          message: "Pendent Record confirmation",
          storagePedidosPOS,
        });
      return storagePedidosPOS;
    };

    const removeRecordedConfirmationOrderFromStorageQueueAsync = async (
      responseIds: responseSyncPedidoPos[]
    ) => {
      const storagePedidosPos = await localStorageRepository.get<PedidoPos[]>(
        KEY
      );
      const newPendentStoragePedidosPos: PedidoPos[] = [];
      storagePedidosPos?.forEach((storagePedido) => {
        if (
          responseIds.findIndex(
            (responseIds) =>
              responseIds.pedidoPOSId === storagePedido.pedidoPOSId
          ) === -1
        ) {
          newPendentStoragePedidosPos.push(storagePedido);
        } else {
          orderRepository.add(
            {
              id: storagePedido.pedidoPOSId,
              isOfflineRechargeRecordConfirmed: true,
            } as Order,
            "Confirmação da gravação de recarga"
          );
        }
      });
      await localStorageRepository.remove(KEY);
      addLog &&
        addLog("[CashlessOfflineRepository]", {
          message: "UpdateStorage",
          newPendentStoragePedidosPos,
        });
      await savePendentConfirmationRecordOfflineOrders(
        newPendentStoragePedidosPos
      );
    };

    const savePendentConfirmationRecordOfflineOrders = async (
      pedidosPOS: PedidoPos[]
    ) => {
      const storagePedidosPOS: PedidoPos[] =
        (await localStorageRepository.get<PedidoPos[]>(KEY)) ?? [];

      const newPendentOrder = [...storagePedidosPOS, ...pedidosPOS];
      addLog &&
        addLog("[CashlessOfflineRepository]", {
          message: "Add Orders",
          newPendentOrder,
        });
      localStorageRepository.post(KEY, newPendentOrder);
    };

    const markAsRecorded = async (orderId: string) => {
      let storagePedidosPOSConfirmationRecord =
        await localStorageRepository.get<PedidoPos[]>(KEY);

      if (
        storagePedidosPOSConfirmationRecord &&
        storagePedidosPOSConfirmationRecord?.length > 0
      ) {
        const index = storagePedidosPOSConfirmationRecord.findIndex(
          (item) => item.pedidoPOSId === orderId
        );
        if (index >= 0) {
          storagePedidosPOSConfirmationRecord[index].isDataRecorded = true;

          try {
            await localStorageRepository.remove(KEY);
            await savePendentConfirmationRecordOfflineOrders(
              storagePedidosPOSConfirmationRecord
            );
            addLog &&
              addLog("[CashlessOfflineRepository]", {
                message: "Update Orders",
                storagePedidosPOSConfirmationRecord,
              });
          } catch (error) {
            addLog && addLog("[Error][markAsRecorder]", error);
          }
        }
      }
    };

    return {
      getStoragePendentRecordConfirmationOrder,
      removeRecordedConfirmationOrderFromStorageQueueAsync,
      savePendentConfirmationRecordOfflineOrders,
      markAsRecorded,
    };
  };
